import { MASCOT } from "@/lib/mascot";
import { cn as cx } from "@/lib/utils";

/** Pangolin professor mascot image. Sizes: xs, sm, md, lg, hero. */
export function Mascot({ size = "md", className, ring = true, alt }) {
  const sizes = {
    xs: "w-10 h-10",
    sm: "w-16 h-16",
    md: "w-24 h-24",
    lg: "w-36 h-36",
    hero: "w-56 h-56 sm:w-72 sm:h-72",
  };
  return (
    <img
      src={MASCOT.img}
      alt={alt || `${MASCOT.cn} · ${MASCOT.en}`}
      className={cx(
        sizes[size],
        ring && "rounded-full ring-4 ring-white shadow-xl",
        "object-cover object-center bg-gradient-to-br from-amber-50 to-emerald-50",
        className,
      )}
      loading="lazy"
      data-testid="mascot-image"
    />
  );
}

export default Mascot;
